{
  "navbar": {
    "signedInAs": "Signed in as",
    "logout": "Log out"
  }
}
